export default {
    regularHotelVoucher: "RegularHotelVoucher",
    externalMultiVoucher: "ExternalMultiVoucher",
    webshopAccessCode: "WebshopAccessCode",
    externalTravelVoucher: "ExternalTravelVoucher",
    otherExternalVoucher: "OtherExternalVoucher"
};
